import { API_ENDPOINT } from 'utils/constants';
import { submit } from 'utils/proxy';

const url = `${API_ENDPOINT}/api/v1`;

const reportService = {
  reportStatusList,
  getUrlDownload,
  generate
};

function reportStatusList(options = {}){
  const {page, size, dateCreated, userId, sort} = options;
  const params = {
    size: size ? size : 10,
    page: page ? page :  1,
    sort: sort ? sort : '-dateCreated',
  };

  if (dateCreated) params.dateCreated = dateCreated;
  if (userId) params.userId = userId;

  return submit('GET', `${url}/reporting_status/list`, params, {});
}

function getUrlDownload(data = {}){
  const {fileName, userId} = data;
  const params = {
    fileName: fileName,
    userId: userId
  };

  return submit('GET', `${url}/reporting/download`, params, {});
}

function generate(data){
  return submit('POST', `${url}/reporting/generate`, data, {});
}
export default reportService;
